import React from "react";
import styles from "./ToggleSwitch.module.css";

/**
 * A reusable toggle switch button.
 * Props:
 *  - checked: boolean, on/off state
 *  - onClick: func, click handler
 *  - disabled: boolean, whether the switch is disabled
 */
const ToggleSwitch = ({ checked, onClick, disabled }) => (
  <button
    type="button"
    className={styles.toggleButton}
    onClick={onClick}
    disabled={disabled}
  >
    <span className={`${styles.label} ${checked ? styles.checkLevel : ""}`}>{checked ? "Active" : "Inactive"}</span>
    <span className={`${styles.track} ${checked ? styles.checked : ""}`}>
      <span className={styles.thumb} />
    </span>
  </button>
);

export default ToggleSwitch;
